import React from 'react';
import made_with_io_logo from 'images/landing/made_with_io_logo.svg'

const Image = ({ guide }) => {
  if (!guide) {
    return null;
  }

  return (
    <div className="image">
      <img className="image-headline"
           alt={guide.image_alt_attribute || guide.title}
           src={guide.image_url || guide.image}
           loading="lazy" />
      <span className="image-title">
        <span>
          <p><a href={guide.guide_url} target="_blank" rel="noopener noreferrer">{guide.title}</a></p>
        </span>
        <img alt="Made with Adafruit IO Logo"
             src={made_with_io_logo}
             loading="lazy" />
      </span>
    </div>
  );
};

export default Image;
